import React, { useState } from 'react';
import OddsRow from './OddsRow';

export default function MarketSection({ market, onSelectBet }) {
  const [open, setOpen] = useState(true);
  const stop = (e) => e.preventDefault();
  return (
    <div className="market_section">
      <p>
        <span className="mrkname">{market.name}</span>
        <a href="#!" className="add-pin" onClick={stop} title="Pin"><i className="bi bi-bookmark" /></a>
        <button type="button" className="btn btn_cashout" disabled>Cashout</button>
        <button type="button" className="btn btn_losscut" disabled>loss cut</button>
        <span className="min-max">{` ${market.minmax} `}
          <a href="#!" className="ms-2 game-rules-icon" onClick={stop} title="Rules"><span><i className="bi bi-info-square-fill" /></span></a>
          <a href="#!" className="an-collapse" onClick={(e) => { stop(e); setOpen((o) => !o); }} aria-expanded={open} />
        </span>
      </p>
      <div className={`collapse${open ? ' show' : ''}`}>
        <div>
          <div className="row align-items-center oddsHeader">
            <div className="col-lg-6 col-md-5 col-8 px-0" />
            <div className="col-lg-6 col-md-7 col-4 px-0">
              <div className="btn-group">
                <button type="button" className="ex-bl d-none d-md-block" />
                <button type="button" className="ex-bl d-none d-md-block" />
                <button type="button" className="back">back</button>
                <button type="button" className="lay">lay</button>
                <button type="button" className="ex-bl d-none d-md-block" />
                <button type="button" className="ex-bl d-none d-md-block" />
              </div>
            </div>
          </div>
          {market.rows.map((row, i) => <OddsRow key={i} row={row} marketName={market.name} onSelectBet={onSelectBet} />)}
        </div>
      </div>
    </div>
  );
}
